module.exports = __webpack_public_path__ + "static/media/house.3e0121b6.webp";